import '../../App.css';
import React, { useContext, useEffect, useCallback, useState } from 'react';
import { ApiContext } from "../../context/ApiContext";
import Header from '../../components/header/Header';
import MenuLateral from '../../components/menu/MenuLateral'
import Footer from '../../components/footer/Footer'
import { ColumnDirective, ColumnsDirective, GridComponent, Inject, Page, Toolbar, Sort } from '@syncfusion/ej2-react-grids';
import { L10n } from '@syncfusion/ej2-base';
import { FaPlus } from 'react-icons/fa'
import { IoIosWarning, IoIosCheckmarkCircle } from "react-icons/io";
import { TbPencil, TbTrash } from "react-icons/tb";
import { StyleContext } from '../../context/StyleContext';
import ModalCadastrarCargo from '../../components/modal/ModalCadastrarCargo';
import ModalEditarCargo from '../../components/modal/ModalEditarCargo';
import ModalExcluirCargo from '../../components/modal/ModalExcluirCargo';
import Tabela from '../../components/Tabela';

function Cargo() {
    const { Success, Error, openModal, setOpenModal, CargosConsulta, ListaCargoConsulta, loading, modalEditarCargo, setModalEditarCargo, setEdicaoCargo, setCargoAtualKey, modalExcluirCargo, setModalExcluirCargo, Permissao, ListaFiltroCargo, totalRegistrosCargo, filtroCargo, totalRegistrosFiltroCargo } = useContext(ApiContext)
    const { h3Demanda, btnCriar, corTerciaria } = useContext(StyleContext)

    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize] = useState(10);
    const [searchTerm, setSearchTerm] = useState("");

    const EditCargo = (props) => {
        setModalEditarCargo(true)
        setCargoAtualKey(props.key)
        setEdicaoCargo(props)
    }

    const DeletarCargo = (props) => {
        setCargoAtualKey(props.key)
        setModalExcluirCargo(true)
    }

    useEffect(() => {
        if (searchTerm.trim() !== "") {
            ListaFiltroCargo(searchTerm, currentPage, pageSize);
        } else {
            ListaCargoConsulta(currentPage, pageSize);
        }
    }, [currentPage, searchTerm]);

    const totalRegistros = searchTerm.trim() !== "" ? totalRegistrosFiltroCargo : totalRegistrosCargo;
    const totalPages = Math.max(1, Math.ceil((totalRegistros || 0) / pageSize));

    return (
        <div>
            <Header pagina={'Cadastros'} subpagina={'Cadastrar cargo'}></Header>
            <MenuLateral></MenuLateral>
            {modalEditarCargo &&
                <ModalEditarCargo currentPage={currentPage} />
            }
            {modalExcluirCargo &&
                <ModalExcluirCargo currentPage={currentPage}/>
            }
            {Success &&
                <div className='success'>
                    <IoIosCheckmarkCircle className='error-icon' />{Success}
                </div>
            }
            {Error &&
                <div className='error'>
                    <IoIosWarning className='error-icon' />{Error}
                </div>
            }
            <div className='container-principal'>
                <div className='demanda-header'>
                    {openModal &&
                        <ModalCadastrarCargo closeModal={setOpenModal} currentPage={currentPage}/>
                    }
                    {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                        <button className='btn-dash btn-criar' style={btnCriar} onClick={() => setOpenModal(true)}><FaPlus style={{ marginRight: "10px" }} />Cadastrar cargo</button>
                    }
                </div>
                {loading ? (
                    <div className="loading-screen">
                        <div className="loader-container">
                            <div className="spinner"></div>
                        </div>
                    </div>
                ) : (
                    <div className='card card-table'>
                        <h3 className='h3-demanda' style={h3Demanda}>Cargos cadastrados</h3>
                        <Tabela
                            data={searchTerm.trim() !== "" ? filtroCargo : CargosConsulta}
                            columns={[
                                { label: "Descrição", field: "descricao", width: "40%", render: (x) => x.descricao || "-" },
                                {
                                    label: "Opções",
                                    width: "10%",
                                    align: "center",
                                    render: (x) => (
                                        <div style={{ display: "flex", justifyContent: "center" }}>
                                            <button onClick={() => EditCargo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                <TbPencil />
                                            </button>
                                            {(!!Permissao.find(item => item.menu.descricao === "CADASTROS" && item.edicao === true)) &&
                                                <button onClick={() => DeletarCargo(x)} className='btn-dem' style={{ color: `${corTerciaria}` }}>
                                                    <TbTrash />
                                                </button>
                                            }
                                        </div>
                                    ),
                                },
                            ]}
                            loading={loading}
                            currentPage={currentPage}
                            totalPages={totalPages}
                            setCurrentPage={setCurrentPage}
                            searchTerm={searchTerm}
                            setSearchTerm={setSearchTerm}
                            onSearch={(term) => {
                                setCurrentPage(1);
                                if (term.trim() !== "") {
                                    ListaFiltroCargo(term, 1, 10);
                                } else {
                                    ListaCargoConsulta(1, 10);
                                }
                            }}
                            corTerciaria={corTerciaria}
                        />
                    </div>
                )}
            </div>
            <Footer></Footer>
        </div>
    );
}

export default Cargo;